import Vue from 'vue';
import _ from 'lodash';
import {
    GET_CAR_BRAND_REQUEST,
    GET_CAR_BRAND_SUCCESS,
    GET_CAR_BRAND_FAILURE,
    GET_CAR_LINE_REQUEST,
    GET_CAR_LINE_SUCCESS,
    GET_CAR_LINE_FAILURE,
    GET_CAR_MODEL_REQUEST,
    GET_CAR_MODEL_SUCCESS,
    GET_CAR_MODEL_FAILURE,
    CLEAR_LINE_DATA,
    CLEAR_MODEL_DATA,
} from '../mutationTypes';
import {
    setBrandSession,
    getBrandSession,
} from '../../utils/session';

const state = {
    brandLoading: false,
    lineLoading: false,
    modelLoading: false,
    brandData: [],
    lineData: [],
    modelData: [],
};

const mutations = {
    [GET_CAR_BRAND_REQUEST](state) {
        state.brandLoading = true;
    },
    [GET_CAR_BRAND_SUCCESS](state, res) {
        state.brandLoading = false;

        state.brandData = res;
    },
    [GET_CAR_BRAND_FAILURE](state) {
        state.brandLoading = false;
    },
    [GET_CAR_LINE_REQUEST](state) {
        state.lineLoading = true;
    },
    [GET_CAR_LINE_SUCCESS](state, res) {
        state.lineLoading = false;

        state.lineData = res;
    },
    [GET_CAR_LINE_FAILURE](state) {
        state.lineLoading = false;
    },
    [GET_CAR_MODEL_REQUEST](state) {
        state.modelLoading = true;
    },
    [GET_CAR_MODEL_SUCCESS](state, res) {
        state.modelLoading = false;

        state.modelData = res;
    },
    [GET_CAR_MODEL_FAILURE](state) {
        state.modelLoading = false;
    },
    [CLEAR_LINE_DATA](state) {
        state.lineData = [];
        state.modelData = [];
    },
    [CLEAR_MODEL_DATA](state) {
        state.modelData = [];
    }
};

export const actions = {
    async getCarBrand({ commit }) {
        commit(GET_CAR_BRAND_REQUEST);

        const brandSession = getBrandSession();
        let res = [];

        if (!_.isEmpty(brandSession)) {
            res = brandSession;
        } else {
            res = await Vue.$ajax.get('getBrandList');
            if (!res.errorType && !_.isEmpty(res)) {
                setBrandSession(res);
            }
        }

        if (!res.errorType) {
            commit(GET_CAR_BRAND_SUCCESS, res);
        } else {
            commit(GET_CAR_BRAND_FAILURE);
        }
    },
    async getCarLine({ commit }, brandId) {
        commit(GET_CAR_LINE_REQUEST);

        const res = await Vue.$ajax.get('getLineList', {brandId});

        if (!res.errorType) {
            commit(GET_CAR_LINE_SUCCESS, res);
        } else {
            commit(GET_CAR_LINE_FAILURE);
        }
    },
    async getCarModel({ commit }, lineId) {
        commit(GET_CAR_MODEL_REQUEST);

        const res = await Vue.$ajax.get('getModelList', {lineId});

        if (!res.errorType) {
            commit(GET_CAR_MODEL_SUCCESS, res);
        } else {
            commit(GET_CAR_MODEL_FAILURE);
        }
    },
    clearLineData({ commit }) {
        commit(CLEAR_LINE_DATA);
    },
    clearModelData({ commit }) {
        commit(CLEAR_MODEL_DATA);
    }
};

export default {
    state,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/carModel.js